/** The revision row displayed on the self-pay price table and quoted on revision pages. */
export const REVISION_PRICE = {
  procedure: "Revision Surgery",
  to: "/services/revisions",
  anchor: "revision-surgery-cost",
  facility: "$14,000 (1 day)",
  anesthesia: "$1,400*",
  physician: "$10,000",
  total: "$25,400*",
};

export const revisionPriceSentence =
  `Without insurance, the estimated self-pay total for revision surgery is ${REVISION_PRICE.total.replace(/\*$/, "")}.`;

/** Spanish twin of revisionPriceSentence; reads the same REVISION_PRICE total. */
export const revisionPriceSentenceEs =
  `Sin seguro, el total estimado de pago propio para la cirugía de revisión es de ${REVISION_PRICE.total.replace(/\*$/, "")}.`;
